import { Calculator } from './components';

function App() {
  
  return (
    <div>
      <Calculator/>
    </div>
  );
}

export default App;
